import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/Nav";
import { DonateModal } from "@/components/DonateModal";
import { DonateNudge } from "@/components/DonateNudge";
import { InstallPWA } from "@/components/InstallPWA";
import { RouteTracker } from "@/components/RouteTracker";
import { ReadAloud } from "@/components/ReadAloud";
import { Home } from "@/pages/Home";
import { Models } from "@/pages/Models";
import { Refinery } from "@/pages/Refinery";
import { Library } from "@/pages/Library";
import { Coach } from "@/pages/Coach";
import { Techniques } from "@/pages/Techniques";
import { Recap } from "@/pages/Recap";
import { AdLab } from "@/pages/AdLab";
import { Business } from "@/pages/Business";
import { Admin } from "@/pages/Admin";
import { Blog } from "@/pages/Blog";
import { BlogPost } from "@/pages/BlogPost";
import { Shop } from "@/pages/Shop";
import { ShopSuccess } from "@/pages/ShopSuccess";
import { PrintReady } from "@/pages/PrintReady";
import { BusinessSuccess } from "@/pages/BusinessSuccess";
import { Whoracle } from "@/pages/Whoracle";

const TOAST_OPTIONS = {
  style: {
    background: "#0a0a0a",
    border: "1px solid rgba(255,255,255,0.15)",
    color: "#ededed",
    fontFamily: "'JetBrains Mono', monospace",
    borderRadius: 0,
    fontSize: "12px",
  },
};

function App() {
  const [donateOpen, setDonateOpen] = useState(false);
  const openDonate = () => setDonateOpen(true);

  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Nav onDonate={openDonate} />
        <Routes>
          <Route path="/" element={<Home onDonate={openDonate} />} />
          <Route path="/models" element={<Models />} />
          <Route path="/refinery" element={<Refinery />} />
          <Route path="/library" element={<Library />} />
          <Route path="/coach" element={<Coach />} />
          <Route path="/techniques" element={<Techniques />} />
          <Route path="/recap" element={<Recap />} />
          <Route path="/adlab" element={<AdLab />} />
          <Route path="/business" element={<Business />} />
          <Route path="/business/success" element={<BusinessSuccess />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/success" element={<ShopSuccess />} />
          <Route path="/print-ready" element={<PrintReady />} />
          <Route path="/whoracle" element={<Whoracle />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <DonateModal open={donateOpen} onClose={() => setDonateOpen(false)} />
        <DonateNudge onOpen={openDonate} />
        <InstallPWA />
        <ReadAloud />
        <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
